import React from 'react'

import Translator from 'bazinga-translator'

import { HeaderWrapper } from '../../../../components/GamesCategoryGrid/styled/HeaderWrapper'
import { Label } from '../../../../components/GamesCategoryGrid/styled/Label'
import { GET_TOURNAMENT_DETAILS_URL } from '../../../Tournaments/constants'
import { TournamentWithMembership } from '../../../Tournaments/types/Tournament'

type Props = Pick<TournamentWithMembership, 'id' | 'name'>

export function Header({ id, name }: Props) {
  const link = GET_TOURNAMENT_DETAILS_URL(id)

  return (
    <HeaderWrapper>
      <Label link={link}>{Translator.trans('games_in_tournament', { name }, 'tournaments')}</Label>
    </HeaderWrapper>
  )
}
